import React from "react";
import { droneCapabilities } from "@/data/serviceCatalog";
import { AA } from "@/constants/testIds";
import {
  Drone as DroneIcon,
  Buildings,
  Thermometer,
  MapTrifold,
  VideoCamera,
  ChartLineUp,
} from "@phosphor-icons/react";

const DRONE_IMG_1 =
  "https://images.unsplash.com/photo-1723107638858-331404b1a09a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxkcm9uZSUyMGNvbnN0cnVjdGlvbiUyMHNpdGUlMjBhZXJpYWx8ZW58MHx8fHwxNzgwOTkyMDI3fDA&ixlib=rb-4.1.0&q=85";

const ICONS = {
  inspection: Buildings,
  mapping: MapTrifold,
  aerial_doc: VideoCamera,
  thermal: Thermometer,
  real_estate: DroneIcon,
  construction_monitoring: ChartLineUp,
};

export default function Drone() {
  return (
    <section id="drone" className="relative bg-[#0A0A0A] py-24 lg:py-32 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="label-mono mb-5">03 / Drone Division — FAA Part 107</div>
            <h2 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
              Eyes overhead.<br />
              <span className="text-[#0066FF]">Truth in pixels.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-white/60 text-[15px] leading-relaxed">
            LiDAR, photogrammetry, multispectral and thermal — captured at altitude, tied
            to ground control, delivered as orthos, point clouds and georeferenced media.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-0 hairline">
          {/* Image panel */}
          <div className="lg:col-span-5 relative reticle border-b lg:border-b-0 lg:border-r border-white/10 min-h-[360px]">
            <img
              src={DRONE_IMG_1}
              alt="Drone overhead view of a construction site"
              className="w-full h-full object-cover opacity-85"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-[#0A0A0A]/70 via-transparent to-[#0A0A0A]/30" />
            <div className="absolute top-4 left-4 right-4 flex items-center justify-between font-mono text-[10px] tracking-[0.22em] uppercase text-white/80">
              <span>CAM · DJI M350 RTK</span>
              <span className="text-[#FF4500]">REC ●</span>
            </div>
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between font-mono text-[10px] tracking-[0.22em] uppercase text-white/70">
              <span>ALT 240 ft AGL</span>
              <span>GSD 0.6 cm/px</span>
              <span>RTK · FIX</span>
            </div>
          </div>

          {/* Grid of capabilities */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2">
            {droneCapabilities.map((c, i) => {
              const Icon = ICONS[c.key] || DroneIcon;
              return (
                <div
                  key={c.key}
                  data-testid={AA.droneCard(c.key)}
                  className="service-card p-7 border-b border-r border-white/10 last:border-b-0 sm:[&:nth-child(2n)]:border-r-0 sm:[&:nth-last-child(-n+2)]:border-b-0 bg-transparent hover:bg-white/[0.02]"
                >
                  <div className="flex items-center justify-between mb-4">
                    <span className="font-mono text-[10px] tracking-[0.22em] text-[#FF4500]">
                      D-{String(i + 1).padStart(2, "0")}
                    </span>
                    <Icon size={22} className="text-white/80" weight="duotone" />
                  </div>
                  <h3 className="font-display font-bold text-white text-xl tracking-tight mb-2">
                    {c.title}
                  </h3>
                  <p className="text-white/55 text-[14px] leading-relaxed">{c.body}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
